import React, { useState } from 'react';
import { Button } from './ui/button';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from './ui/command';
import { Check, ChevronsUpDown } from 'lucide-react';

/**
 * Searchable Template Combobox Component
 * Reusable across CRM and Franchise modules
 */
export function TemplateCombobox({ templates, value, onChange, placeholder, testId }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  
  const selectedTemplate = templates.find(t => t.id === value);
  
  const filteredTemplates = templates.filter(t => 
    t.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-full justify-between mt-1 font-normal"
          data-testid={testId}
        >
          {selectedTemplate ? selectedTemplate.name : placeholder || "Select template..."}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[300px] p-0" align="start">
        <Command>
          <CommandInput 
            placeholder="Search templates..." 
            value={search}
            onValueChange={setSearch}
          />
          <CommandList>
            <CommandEmpty>No templates found.</CommandEmpty>
            <CommandGroup>
              {filteredTemplates.map((template) => (
                <CommandItem
                  key={template.id}
                  value={template.name}
                  onSelect={() => {
                    onChange(template.id);
                    setOpen(false);
                    setSearch('');
                  }}
                >
                  <Check className={`mr-2 h-4 w-4 ${value === template.id ? 'opacity-100' : 'opacity-0'}`} />
                  {template.name}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}

export default TemplateCombobox;
